<div class="w-full max-w-[1200px] mx-auto">
<div class="flex w-full sm:pt-[80px] pb-[40px] py-0 flex-col items-start sm:px-[24px]">
    <div class="flex flex-col items-start gap-12 self-stretch">
        <div class="flex flex-col sm:gap-5 px-[24px] py-[32px] items-start gap-[16px] self-stretch">
            <span
                class="text-[#00B884] text-center font-[Manrope] text-[16px] not-italic font-medium leading-[17px] tracking-[1px] uppercase">
                {{'BENEFITS' | translate}}
            </span>
            <h2
                class="self-stretch text-[#1B1B1B] font-[Manrope] text-[45px] not-italic font-bold leading-[58px] tracking-[-0.9px]">
                <span class="text-[#F2305E]">{{'Why' | translate}}</span> {{'to choose Car Insurance provided by Bao Long?' | translate}}
            </h2>
            <p
                class="self-stretch text-[#1B1B1B] font-[Manrope] text-[20px] not-italic font-normal leading-[140%] tracking-[-0.4px]">
                {{'More than just car insurance — we provide trusted protection, hassle-free services, and added
                benefits to
                make every
                journey safer and simpler' | translate}}
            </p>
            <span class="w-[100px] h-[5px] rounded-[5px] bg-[#FD71AF] block"></span>
            <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-[32px] w-full">
                <!-- Card 1 -->
<div class="relative rounded-tl-[35px] overflow-hidden border-t-2 border-[#f53773]">
    <!-- Left gradient border -->
    <div class="absolute left-[2px] top-0 bottom-0 w-[2px] bg-gradient-to-b from-[#f53773] to-white rounded-tl-[35px]">
    </div>

    <!-- Inner content -->
    <div class="relative ml-[4px] flex flex-col justify-between items-center p-6 
                bg-gradient-to-b from-[#FDFDFD] to-[#FDDBE6] 
                rounded-tl-[35px] h-[300px] lg:h-[350px]">
        <span class="self-stretch text-[#1B1B1B] font-[Manrope] text-[20px] font-extrabold leading-[140%]">
            {{'Comprehensive, flexible coverage available 24/7' | translate}}
        </span>
        <div class="w-[200px] h-[200px] bg-[url('/png/24hr.png')] bg-center bg-cover bg-no-repeat"></div>
    </div>
</div>

<!-- Card 2 -->
<div class="relative rounded-tl-[35px] overflow-hidden border-t-2 border-[#f53773]">
    <div class="absolute left-[2px] top-0 bottom-0 w-[2px] bg-gradient-to-b from-[#f53773] to-white rounded-tl-[35px]">
    </div>
    <div class="relative ml-[4px] flex flex-col justify-between items-center p-6 
                bg-gradient-to-b from-[#FDFDFD] to-[#FDDBE6] 
                rounded-tl-[35px] h-[300px] lg:h-[350px]">
        <span class="self-stretch text-[#1B1B1B] font-[Manrope] text-[20px] font-extrabold leading-[140%]">
            {{'Simple, instant online registration' | translate}}
        </span>
        <div class="w-[200px] h-[200px] bg-[url('/png/livwellsignup.png')] bg-center bg-cover bg-no-repeat"></div>
    </div>
</div>

<!-- Card 3 -->
<div class="relative rounded-tl-[35px] overflow-hidden border-t-2 border-[#f53773]">
    <!-- Left gradient border with multi-color -->
    <div class="absolute left-[2px] top-0 bottom-0 w-[2px] bg-gradient-to-b from-[#f53773] to-white rounded-tl-[35px]">
    </div>
    <div class="relative ml-[4px] flex flex-col justify-between items-center p-6 
                bg-gradient-to-r from-[#FFF5F8] to-[#FDDBE6] 
                rounded-tl-[35px] h-[300px] lg:h-[350px]">
        <span class="self-stretch text-[#1B1B1B] font-[Manrope] text-[20px] font-extrabold leading-[140%]">
            {{'Fast and professional claims service' | translate}}
        </span>
        <div class="w-[200px] h-[200px] bg-[url('/png/insurance1.png')] bg-center bg-cover bg-no-repeat"></div>
    </div>
</div>

<!-- Card 4 -->
<div class="relative rounded-tl-[35px] overflow-hidden border-t-2 border-[#f53773]">
    <div class="absolute left-[2px] top-0 bottom-0 w-[2px] bg-gradient-to-b from-[#f53773] to-white rounded-tl-[35px]">
    </div>
    <div class="relative ml-[4px] flex flex-col justify-between items-center p-6 
                bg-gradient-to-b from-[#FDFDFD] to-[#FDDBE6] 
                rounded-tl-[35px] h-[300px] lg:h-[350px]">
        <span class="self-stretch text-[#1B1B1B] font-[Manrope] text-[20px] font-extrabold leading-[140%]">
            {{'Free home delivery of your certificate' | translate}}
        </span>
        <div class="w-[200px] h-[200px] bg-[url('/png/insurance.png')] bg-center bg-cover bg-no-repeat"></div>
    </div>
</div>
            </div>

            <div id="leads-form"
                class="flex flex-col w-full sm:w-full sm:p-[48px_60px] p-[32px_24px_16px_24px] sm:gap-[60px] gap-[24px] justify-center items-start self-stretch rounded-[48px] border border-[#D9D9D9] bg-white shadow-[0_4px_80px_0_rgba(0,0,0,0.08)]">
                <div class="flex flex-col w-full justify-center items-start gap-[16px]">
                    <span
                        class="text-[#00B884] text-center font-[Manrope] text-[16px] not-italic font-medium leading-[17px] tracking-[1px] uppercase">
                        {{'REGISTER FOR CONSULTANT' | translate}}
                    </span>
                    <h2 class="self-stretch text-black font-[Manrope] 
         text-[24px] sm:text-[45px] 
         not-italic font-extrabold 
         leading-[120%] 
         tracking-[-0.96px] sm:tracking-[-0.9px]">
                        <span class="text-[#F2305E]">{{'Maximize your benefits ' | translate}}</span> {{'with a variety
                        of Car
                        Insurance packages' | translate}}
                    </h2>
                    <p class="self-stretch font-[Manrope] 
         text-[12px] sm:text-[22px] 
         font-medium 
         not-italic 
         leading-normal 
         text-[rgba(27,27,27,0.80)] sm:text-[#121212] 
         tracking-[-0.24px] sm:tracking-normal">
                        {{'Complete your registration to receive exclusive offers from LivWell' | translate}}
                    </p>
                    <span class="block w-[95%] h-[1.669px] bg-[#D9DBE9]"></span>
                </div>
                <div class="flex flex-col gap-8 self-stretch">
                    <form [formGroup]="form">
                        <!-- Wrapper -->
                        <div
                            class="flex flex-col md:flex-row items-start gap-[20px] md:gap-[38px] self-stretch mb-[18px]">
                            <!-- Name Input -->
                            <div class="flex-1 w-full flex flex-col">
                                <input type="text" formControlName="name"
                                    placeholder="{{'What is your name?' | translate}}"
                                    class="w-full h-[64.577px] px-[30.492px] py-[22.869px] rounded-[50px] border-[1.906px] border-[rgba(117,125,138,0.32)] bg-white" />

                                <!-- Error reserved space -->
                                <div class="mt-1 min-h-[20px] text-[#F03457] text-sm">
                                    @if (form.get('name')?.invalid && (form.get('name')?.touched ||
                                    form.get('name')?.dirty)) {
                                    @if (form.get('name')?.errors?.['required']) {
                                    <span class="ml-2">{{'Name is required.' | translate}}</span>
                                    }
                                    }
                                </div>
                            </div>

                            <!-- Phone Input -->
                            <div class="flex-1 w-full flex flex-col">
                                <input #phoneInput id="newPhone" formControlName="newPhone" type="text"   (input)="formatPhone($event)"
                                    placeholder="{{ 'What is your phone number?' | translate }}"
                                    class="w-full h-[64.577px] px-[30.492px] py-[22.869px] rounded-[50px] border-[1.906px] border-[rgba(117,125,138,0.32)] bg-white" />

                                <!-- Error reserved space -->
                                <div class="mt-1 min-h-[20px] text-[#F03457] text-sm">
                                    @if (form.get('newPhone')?.invalid && (form.get('newPhone')?.touched ||
                                    form.get('newPhone')?.dirty))
                                    {
                                    @if (form.get('newPhone')?.errors?.['required']) {
                                    <span class="ml-2">{{'Phone number is required.'|translate}}</span>
                                    }
                                    @if (form.get('newPhone')?.errors?.['pattern'] || form.get('newPhone')?.errors?.['invalidPhone']) {
                                    <span>{{'Please enter a valid 10-digit phone number.' | translate}}</span>
                                    }
                                    }
                                </div>
                            </div>
                        </div>
                        <!-- Brand + Model -->
                        <div
                            class="flex flex-col md:flex-row items-start gap-[20px] md:gap-[38px] self-stretch mb-[18px]">
                            <!-- Model Input -->
                            <div class="flex-1 w-full flex flex-col">
                                <input #phoneInput id="modelName" formControlName="modelName" type="text"
                                    placeholder="{{'What is your car\'s model line?' | translate}}"
                                    class="w-full h-[64.577px] px-[30.492px] py-[22.869px] rounded-[50px] border-[1.906px] border-[rgba(117,125,138,0.32)] bg-white" />
                                <!-- Reserved error space -->
                                <div class="mt-1 min-h-[20px] text-[#F03457] text-sm">
                                    @if (form.get('modelName')?.invalid && (form.get('modelName')?.touched ||
                                    form.get('modelName')?.dirty)) {
                                    @if (form.get('modelName')?.errors?.['required']) {
                                    <span class="ml-2">{{'Model name is required.' | translate}}</span>
                                    }
                                    }
                                </div>
                            </div>

                            <!-- Brand Select -->
                            <div class="relative flex-1 w-full flex flex-col">
                                <div class="dropdown-container w-full h-[64.577px] px-[30.492px] py-[22.869px] rounded-[50px] border-[1.906px] border-[rgba(117,125,138,0.32)] bg-white text-[#757D8A] appearance-none flex items-center"
                                    (click)="toggleDropdown('brand')">

                                    <!-- Input -->
                                    <input formControlName="carBrand" [value]="selectedBrand" readonly
                                        placeholder="{{ selectedBrand || ('What is your car\'s brand?' | translate) }}"
                                        class="w-full outline-none text-black bg-transparent cursor-pointer" />

                                    <!-- Custom arrow -->
                                    <svg class="pointer-events-none absolute right-[20px] top-1/3 -translate-y-1/2 w-[24px] h-[24px] text-[#757D8A]"
                                        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                        stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>
                                <!-- Dropdown -->
                                <div *ngIf="activeDropdown === 'brand'"
                                    class="z-10 mt-[60px] absolute bg-white shadow-lg  border border-[#232124] w-[100%]">
                                    <div *ngFor="let brand of brands" (click)="selectBrand(brand); closeDropdown()"
                                        class="px-4 py-2 rounded-xl cursor-pointer"
                                        [ngClass]="brand === selectedBrand ? 'text-[#F03457] font-semibold' : 'text-black'">
                                        {{ brand }}
                                    </div>
                                </div>

                                <!-- Reserved error space -->
                                <div class="mt-1 min-h-[20px] text-[#F03457] text-sm">
                                    @if (form.get('carBrand')?.invalid && (form.get('carBrand')?.touched ||
                                    form.get('carBrand')?.dirty))
                                    {
                                    @if (form.get('carBrand')?.errors?.['required']) {
                                    <span class="ml-2">{{'Brand name is required.' | translate}}</span>
                                    }
                                    }
                                </div>
                            </div>
                        </div>
                        <!-- Year Selection -->
                    <div class="dropdown-container relative w-full mb-[38px]">
<div class="relative flex-1">
  <!-- Input container -->
  <div
    class="relative flex items-center justify-between w-full h-[64.577px] px-[30.492px] py-[22.869px]
           rounded-[50px] border-[1.906px] border-[rgba(117,125,138,0.32)] 
           bg-white text-[#757D8A] appearance-none cursor-pointer"
    (click)="toggleDropdown('year')"
  >
    <!-- Input -->
    <input
      formControlName="manufacturingYear"
      [value]="selectedYear"
      readonly
      placeholder="{{ selectedYear || ('What year was your Car Manufactured?' | translate) }}"
      class="w-full text-[15px] font-manrope text-[#313131] bg-transparent border-none outline-none placeholder-[#757D8A]"
    />

    <!-- Icon -->
    <svg
      class="w-[24px] h-[24px] text-[#757D8A] flex-shrink-0 ml-2"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
    </svg>
  </div>

  <!-- Dropdown list -->
  <div
    *ngIf="activeDropdown === 'year'"
    class="z-10 absolute top-full left-1/2 -translate-x-1/2 bg-white shadow-xl mt-2 
           border border-[rgba(117,125,138,0.32)] rounded-[20px]
           w-[90vw] sm:w-[96%] lg:w-full max-w-none 
           sm:left-0 sm:translate-x-0 max-h-[220px] 
           overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 dark:scrollbar-thumb-gray-600 scrollbar-track-gray-100 scrollbar-track-transparent"
  >
    <div
      *ngFor="let year of years"
      (click)="selectCarYear(year, $event); closeDropdown()"
      class="px-6 py-2 rounded-xl cursor-pointer hover:bg-gray-100 transition-colors"
      [ngClass]="year === selectedYear ? 'text-[#F03457] font-semibold' : 'text-black'"
    >
      {{ year }}
    </div>
  </div>

  <!-- Error message -->
  @if (
    form.get('manufacturingYear')?.invalid &&
    (form.get('manufacturingYear')?.touched || form.get('manufacturingYear')?.dirty)
  ) {
    <div class="mt-1 text-[#F03457] text-sm">
      @if (form.get('manufacturingYear')?.errors?.['required']) {
        <span class="ml-2">{{ 'Manufacturing year is required.' | translate }}</span>
      }
    </div>
  }
</div>

                    </div>
                        <!-- Insurance Expiry -->
                       <div class="relative w-full mb-[38px]" (click)="toggleDropdown('calender')">
                        <app-calender-picker
                            [active]="activeDropdown"
                            [carInsurance]="true"
                            [placeholder]="'When is your current car insurance expected to expire?' | translate"
                            [showIcon]="true"
                            (closeActive)="closeDropdown()"
                            (toggleActive)="toggleDropdown('calender')"
                            (dateSelected)="onDateSelected($event)">
                        </app-calender-picker>

                        @if (form.get('insuranceExpiry')?.invalid && (form.get('insuranceExpiry')?.touched || form.get('insuranceExpiry')?.dirty)) {
                            <div class="mt-1 text-[#F03457] text-sm">
                            @if (form.get('insuranceExpiry')?.errors?.['required']) {
                                <span class="ml-2">{{ 'InsuranceExpiry year is required.' | translate }}</span>
                            }
                            </div>
                        }
                        </div>
                        <!-- Consent -->
                        <div class="flex items-start  mb-[38px]">
                            <!-- Checkbox -->
                            <div>
                                <label class="inline-block relative align-middle">
                                    <input id="consent" type="checkbox" formControlName="consent"
                                        class="peer bg-white checked:bg-[#F03457] border-[#3C3C3C99] border-2 rounded focus:outline-none w-[28px] h-[28px] appearance-none" />
                                    <span
                                        class="top-0 left-0 absolute flex justify-center items-center bg-[#F03457] opacity-0 peer-checked:opacity-100 rounded w-[28px] h-[28px] transition-opacity pointer-events-none">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5 10.5L9 14.20L15 7.5" stroke="white" stroke-width="4"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </label>
                            </div>

                            <!-- Text -->
                            <div class="ml-3 font-primary flex-1">
                                <label for="consent" class="font-primary text-[#958D90]">
                                    {{'I agree that LivWell may collect, provide, and share all information I have
                                    submitted in this form with Bao Long
                                    Insurance, so that Bao Long Insurance may contact me for consultation and offer Car
                                    Insurance products. In return, Bao
                                    Long Insurance will update LivWell with relevant information regarding the issued
                                    insurance contract for reconciliation
                                    purposes between the two parties.'|
                                    translate}}
                                </label>
                                @if (form.get('consent')?.invalid && (form.get('consent')?.touched ||
                                form.get('consent')?.dirty)) {
                                <div class="mt-2 text-[#F03457]">
                                    <span>{{ 'You must consent to the terms and conditions to proceed.' | translate
                                        }}</span>
                                </div>
                                }
                            </div>
                        </div>
                        <!-- Submit Button -->
                    <button type="button" (click)="onSubmit()" [disabled]="isLoading"
                        class="flex w-full px-[20px] py-[12px] justify-center items-center gap-[8.986px] self-stretch rounded-[89.857px] bg-[#2AD189] text-[#060809] font-[Manrope] text-[20px] not-italic font-extrabold leading-normal transition-colors duration-300 hover:bg-[#A4FFD6]">
                    
                        <span *ngIf="!isLoading">{{ 'SUBMIT' | translate }}</span>
                    
                        <span *ngIf="isLoading" class="flex items-center gap-2">
                            <svg class="animate-spin h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                            </svg>
                                                {{'Loading...' | translate}}
                        </span>
                    </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
</div>

<!--OTP-->
<app-car-insurance-otp-model [visible]="showOtpModal" [phoneMasked]="otpPhoneMasked" [countryCode]="otpCountryCode"
    [mobileNo]="otpMobileNo" [errorMsg]="otpErrorMsg"  (resendOtp)="onVerifyPhone()" [loading]="otpLoading" (verified)="onOtpVerified($event)"
    (closed)="onOtpClosed()" (edit)="onOtpEdit()" (zaloVerify)="onOtpZaloVerify()"
    (callVerify)="onOtpCallVerify()"></app-car-insurance-otp-model>